import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';

class SearchInput extends PureComponent {
    _isMounted = false;
    state = {
        inputValue: '',
        isThrolling: false
    }

    SEARCH_TIMEOUT = 1000;

    handleSearch = ({ value, onChange }) => {
        this.setState({
            inputValue: value,
            isThrolling: true
        });

        if (this.throttleKeywordChange) {
            clearTimeout(this.throttleKeywordChange);
        }

        this.throttleKeywordChange = setTimeout(() => {
            this.throttleKeywordChange = null;
            const { inputValue } = this.state;

            onChange(inputValue);

            if (this._isMounted) {
                this.setState({ isThrolling: false });
            }
        }, this.SEARCH_TIMEOUT);
    }

    handleCloseClick = ({ onChange }) => {
        this.handleSearch({ value: '', onChange });
    }

    componentDidMount() {
        const { defaultValue } = this.props;

        this._isMounted = true;

        this.setState({
            inputValue: defaultValue
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {
            name,
            onBlur,
            onChange,
            required,
            disabled,
            placeholder,
            autocomplete,
            className
        } = this.props;

        const { inputValue, isThrolling } = this.state;

        return (
            <div className={`Input ${className}`}>
                <div className={'Input__wrapper'}>
                    <div className='Input__leftIcon'>
                        <FontAwesomeIcon icon={faSearch} size='lg' />
                    </div>
                    <input
                        id={name}
                        name={name}
                        className='Input__input'
                        disabled={disabled}
                        type='text'
                        value={inputValue || ''}
                        placeholder={placeholder}
                        autoComplete={autocomplete || name}
                        required={required}
                        onBlur={onBlur}
                        onChange={({ target: { value } }) => this.handleSearch({ value, onChange })} />
                    <span />
                    {isThrolling ? <div className='dot-flashing' /> : (
                        (inputValue === '' || inputValue === undefined) ? null
                            : <div className='Input__rightIcon'>
                                <FontAwesomeIcon icon={faTimes} size='lg' onClick={() => this.handleCloseClick({ onChange })} />
                            </div>
                    )}
                </div>
            </div>

        );
    }
}

SearchInput.propTypes = {

    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    form: PropTypes.shape({
        touched: PropTypes.object,
        errors: PropTypes.object
    }),
    disabled: PropTypes.bool,
    className: PropTypes.string,
    type: PropTypes.any,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    autocomplete: PropTypes.string,
    defaultValue: PropTypes.string,
    required: PropTypes.bool
};

SearchInput.defaultProps = {
    className: '',
    isRequired: false,
    name: '',
    type: 'text',
    label: '',
    placeholder: '',
    disabled: false,
    onChange: () => { }
};

export default SearchInput;
